// extracted by mini-css-extract-plugin
export var clients_section = "main_container-module--clients_section--UqA4K";
export var main_shares_item = "main_container-module--main_shares_item--MjoV6";
export var mocap_img = "main_container-module--mocap_img--kkfjZ";
export var modal_header = "main_container-module--modal_header--sfOFK";
export var modal_subtitle = "main_container-module--modal_subtitle--vRl5T";
export var registr_button = "main_container-module--registr_button--McRjb";
export var swiper = "main_container-module--swiper--SOHdj";
export var swiper_container = "main_container-module--swiper_container--IJCiH";
export var toast_success = "main_container-module--toast_success--FNHa5";